import { AdminAccountReportVO } from "../../../../types/admin/AdminAccountReportVO";

export type ProofTitlesType = {PROOF_PP: string; PROOF_TOS: string};

export const dialogTypes = Object.freeze({EDIT_TYPE: 'EDIT_TYPE', CHANGE_STATUS: "CHANGE_STATUS", DELETE: "DELETE", PROOF_PP: "PROOF_PP", PROOF_TOS: "PROOF_TOS"});
export const proofTitles: ProofTitlesType = Object.freeze({PROOF_PP: 'Privacy Policy', PROOF_TOS: 'Terms of Service'});

export const defaultAccount: AdminAccountReportVO = {
    id: '',
    companyName: '',
    activated: false,
    userType: '',
    termsAgreedToDate: '',
    termsAgreedToEmail: '',
    termsAgreedToIp: '',
    termsVersion: null,
    privacyPolicyAgreeToDate: '',
    privacyPolicyAgreedToEmail: '',
    privacyPolicyAgreedToIp: '',
    policyVersion: null,
    email: '',
    username: '',
    customerCode: '',
    createdBy: '',
    creationDate: '',
    lastModifiedBy: '',
    lastModifiedDate: '',
  }
export interface EditAccountDialogType {
  open: boolean;
  onClose: () => void;
  onEditTypeAction: (account: AdminAccountReportVO) => void;
  account: AdminAccountReportVO;
}

export interface DeleteAccountDialogType {
  open: boolean;
  onClose: () => void;
  onDeleteAction: (account: AdminAccountReportVO) => void;
  account: AdminAccountReportVO;
}

export interface ChangeAccountStatusDialogType {
  open: boolean;
  onClose: () => void;
  onChangeAction: (account: AdminAccountReportVO) => void;
  account: AdminAccountReportVO;
}

export interface ProofDialogType {
  open: boolean;
  type: string;
  onClose: () => void;
  account: AdminAccountReportVO;
}

export interface DialogType {
  open: boolean;
  type: string;
}

